/* eslint-disable react/jsx-no-target-blank */
import {useEffect, useState} from 'react'
import axios from 'axios'
import {useDataLayerValue} from '../../../../DataLayer'
import {useAuth} from '../../../../app/modules/auth'

interface Company {
  key: number
  value: string
}
const SidebarFooter = () => {
  const API_URL = process.env.REACT_APP_API_URL
  const [companies, setCompanies] = useState<Company[]>([])
  const [{company}, dispatch] = useDataLayerValue()
  const currentUser = useAuth().currentUser

  const fetchCompanies = async () => {
    try {
      const response = await axios.get(`${API_URL}/companies/v2/ddlist-company`)
      setCompanies(response.data.data)
    } catch (error) {
      console.error('Error fetching companies:', error)
    }
  }

  useEffect(() => {
    fetchCompanies()
  }, [])

  return (
    <div className='app-sidebar-footer flex-column-auto pt-2 pb-6 px-6' id='kt_app_sidebar_footer'>
      {currentUser?.result?.type === 1 && (
        <div className='mt-2'>
          <select
            className='form-select form-select-sm form-select-solid'
            data-kt-select2='true'
            data-placeholder='Select option'
            data-allow-clear='true'
            // value={}
            value={company}
            onChange={(e) => {
              dispatch({
                type: 'SET_COMPANY',
                company: e.target.value,
              })
              // window.location.reload();
              window.location.href = '/dashboard'
            }}
            style={{backgroundColor: '#1e1e2d', borderColor: '#a1a5b7', color: 'white'}}
          >
            <option value='' hidden>
              Select Company
            </option>

            {companies.map((company) => (
              <option value={company.key}>{company.value}</option>
            ))}
          </select>
          {/* {selectedCompany && <p>Selected company: {selectedCompany}</p>} */}
        </div>
      )}
    </div>
  )
}

export {SidebarFooter}
